import React, { DispatchWithoutAction, FC, MouseEvent } from 'react';

import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { checkboxChecked, checkboxUnchecked } from 'assets/icons';

import styles from './styles.module.css';

interface IIndeterminateCheckboxProps {
  isChecked: boolean;
  isHeader?: boolean;
  rowId?: string;
  onChange: DispatchWithoutAction;
}

export const IndeterminateCheckbox: FC<IIndeterminateCheckboxProps> = ({ isHeader, rowId, isChecked, onChange }) => {
  const id = `row-select-${isHeader ? 'header' : rowId}`;

  const stopPropagation = (event: MouseEvent<HTMLDivElement>) => event.stopPropagation();

  return (
    <div className={styles.wrapper} onClick={stopPropagation}>
      <input type="checkbox" id={id} onChange={onChange} hidden />
      <label htmlFor={id}>
        <span className={styles.checkboxIcon}>
          {isChecked ? (
            <SvgWrapper width={18} height={18} details={checkboxChecked} color={isHeader ? '#707070' : '#ffffff'} />
          ) : (
            <SvgWrapper width={15} height={15} details={checkboxUnchecked} />
          )}
        </span>
      </label>
    </div>
  );
};
